import React, { useState } from "react";

import { IoIosFlash } from "react-icons/io";
import CustomButton from "../customButton/CustomButton";

const CouponCard = ({ coupon, setIsTyping, setCouponCode, couponCode }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <>
        <div
          key={coupon.couponCode}
          className="mb-2"
          onClick={() => {
            setIsTyping(false);
            setCouponCode(coupon?.couponCode);
          }}
        >
          <div className="flex items-center my-1">
            <IoIosFlash className="text-yellow-300" />
            <p className="text-[#31a05e] ml-1">Get {coupon?.percentOff}</p>
          </div>
          <div className="flex w-full items-center justify-between">
            <div className="border-dotted border-2 py-1 px-2">{`${coupon?.couponCode}`}</div>
            <CustomButton size="small">
              {coupon.couponCode === couponCode ? "Applied" : "Apply"}
            </CustomButton>
          </div>
        </div>

        <div className="flex text-left text-xs">
          <p>*</p>
          <div>
            <span>
              {isOpen ? (
                <>
                  {coupon?.termAndConditionList.map((tnc, index) => {
                    return (
                      <>
                        <p key={index}>{tnc.termAndCondition}</p>
                      </>
                    );
                  })}
                </>
              ) : (
                <>
                  <p>{coupon?.termAndConditionList[0].termAndCondition}</p>
                </>
              )}
            </span>

            {isOpen ? (
              <span
                className="cursor-pointer"
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
              >
                {" "}
                ...show less
              </span>
            ) : (
              <span
                className="cursor-pointer"
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
              >
                {" "}
                ...see more
              </span>
            )}
          </div>
        </div>
        <hr className="my-3" />
      </>
    </>
  );
};

export default CouponCard;
